import {NavbarSeparatorSiBox} from "./navbar-separator.si.box";

export const NavbarSeparatorSiCisBox = NavbarSeparatorSiBox;